<template>
  <div v-if="activeCountryDetail">
    <table v-if="open" class="detail-list detail-list--opened">
      <tr class="detail-row">
        <td class="detail-title">{{ $t('countryDetails.cNameTitle') }}</td>
        <td class="detail-value">{{ localizedCountryName }} ({{ activeCountryDetail.cId }})</td>
      </tr>
      <tr class="detail-row">
        <td class="detail-title">{{ $t('countryDetails.cCapitalTitle') }}</td>
        <td class="detail-value">{{ localizedCapital }}</td>
      </tr>
      <tr class="detail-row">
        <td class="detail-title">{{ $t('countryDetails.cWikiTitle') }}</td>
        <td class="detail-value">
          <a :href="activeCountryDetail.wiki">{{ $t('countryDetails.wikiLink') }}</a>
        </td>
      </tr>
      <tr>
        <td class="detail-title">{{ $t('countryDetails.attackCount') }}</td>
        <td class="detail-value">
          <AnimatedNumber
            :value="attackByActiveCountry ? attackByActiveCountry : 0"
            :duration="700"
            :round="1"
            easing="easeInOutExpo"
          />
        </td>
      </tr>
    </table>
    <div v-else class="detail-list detail-list--closed">
      {{ localizedCountryName }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import AnimatedNumber from 'animated-number-vue';

export default {
  name: 'CountryInfo',
  props: {
    open: { type: Boolean, default: false }
  },
  components: {
    AnimatedNumber
  },
  computed: {
    ...mapGetters({
      activeCountryDetail: 'mapStore/getActiveCountryDetail',
      attackByActiveCountry: 'eventStore/totalAttackByActiveCountry'
    }),
    localizedCountryName() {
      if (!this.activeCountryDetail) return '';
      const { cId } = this.activeCountryDetail;

      return this.$t(`countries.${cId}.ctry`);
    },
    localizedCapital() {
      if (!this.activeCountryDetail) return '';
      const { cId } = this.activeCountryDetail;

      return this.$t(`countries.${cId}.cap`);
    }
  }
};
</script>

<style lang="scss" scoped>
.detail-list {
  &.detail-list--opened {
    a {
      pointer-events: all;
      color: white;
    }

    .detail-row {
      .detail-title {
        padding: 0 12px 0 0;
      }
    }
  }
}
</style>
